import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    wrapBreadCrumbs: {
        marginTop: 20, 
        marginBottom: 20, 
        display: 'flex', 
        alignItems: 'center',
    },
    breadCrumbs: {
        fontFamily: 'PT Sans,sans-serif',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        height: '36px',
        lineHeight: '36px',
        fontSize: '22px',
        color: '#fff',
        fontWeight: 400,
        padding: '0 0 0 8px',
        marginRight: 12
    },
    arrowBreadCrumbs: {
        width: 20, 
        height: 20,
        fill: '#fff'
    },
}))

export {
    useStyles,
}